/**
 * Is the till's manual-discount control shown? (2026-09-28)
 *
 * The owner, on his Redmi Note 13: the cart showed one of its two lines —
 * the discount row (and the cashier's ceiling above it) sat on the screen
 * for a shop that never gives a discount, pushing the cart off it. „Show it
 * only when the shop really turns it on in Settings."
 *
 * `settings.posDiscount`: true / false once the owner has chosen. Before
 * that (null) the shop's own behaviour decides, so a shop that DOES discount
 * does not lose the control overnight: shown if any active cashier has a
 * ceiling set (084 — only a shop that discounts sets one) or any sale in the
 * loaded history (90 days) carried a discount. Promotions (086) and the
 * loyalty bonus (085) are not this control and always apply.
 */
export function posDiscountOn(
  pref: boolean | null | undefined,
  cashiers: { max_discount_pct?: number | null; active?: boolean }[],
  anyDiscountedSale: boolean,
): boolean {
  if (pref === true || pref === false) return pref
  return anyDiscountedSale || cashiers.some((c) => c.active !== false && c.max_discount_pct != null)
}
